export default __webpack_public_path__ + "static/media/screenshot2_sm.b04d6fd3.jpg";